import React from 'react';

const QuemSomos = () => {
  return (
    <div className="quem-somos">
      <h2>Quem somos</h2>
      <p>
        Mobiliário Profissional Direto da Fábrica para Seu Estabelecimento. <br />
        Na Soluções Mobiliários, você compra diretamente da fábrica, sem intermediários – o que significa economia real para o seu negócio.
      </p>
      <p>
        Especializados em atender bares, hotéis, restaurantes, condomínios e redes do setor de hospitalidade, oferecemos móveis e equipamentos duráveis, com design profissional, materiais de alto desempenho e produção sob medida para a sua necessidade.
      </p>
      <p>
        <ul>🔧 Assessoria especializada desde o planejamento até a entrega</ul>
        <ul>💰 Custos reduzidos com compra direta de fábrica</ul>
        <ul>🪑 Durabilidade e resistência para uso intenso no dia a dia</ul>
        <ul>📦 Logística eficiente para todo o Brasil</ul>
        <ul>🎯 Soluções sob medida para cada tipo de ambiente</ul>
      </p>
      <p>
        Transforme seus espaços com quem entende do seu negócio. Fale com um consultor e solicite um orçamento sem compromisso.
      </p>
      
      {/* Imagem/Galeria de fotos da loja */}
    </div>
  );
};

export default QuemSomos;